import type { AdFields } from '@xing-com/crate-ads-native-ads';
import type { SimilarJobData } from '@xing-com/crate-jobs-helpers';
import { NotOnLarge, OnlyOnLarge } from '@xing-com/layout-primitives';
import type { HeadlineSize } from '@xing-com/typography';

import { ModuleTitle } from '../module-title';

import { StyledGridContainer } from './grid-container';
import { SimilarJobsCarousel } from './similar-jobs-carousel';
import { SimilarJobsGrid } from './similar-jobs-grid';
import { SimilarJobsLoading } from './similar-jobs-loading';

type SimilarJobsModuleProps = {
  isLoading: boolean;
  showCarousel?: boolean;
  similarJobs: SimilarJobData[];
  ads?: AdFields[];
  isLoadingAds?: boolean;
  titleSize?: HeadlineSize;
  titleSizeConfined?: HeadlineSize;
};

export const SimilarJobsModule: React.FC<SimilarJobsModuleProps> = ({
  isLoading = false,
  similarJobs,
  showCarousel = false,
  ads = [],
  isLoadingAds = false,
  titleSize,
  titleSizeConfined,
}: SimilarJobsModuleProps) => {
  if (isLoading || isLoadingAds) {
    return (
      <div>
        <ModuleTitle
          titleKey="JOBS_JOB_DETAILS_SIMILAR_JOBS_HEADLINE"
          size={titleSize}
          sizeConfined={titleSizeConfined}
        />
        <StyledGridContainer variant="FullSize">
          <SimilarJobsLoading count={3} isCarousel={showCarousel} />
        </StyledGridContainer>
      </div>
    );
  }
  if (similarJobs.length === 0) return null;

  return (
    <div>
      <ModuleTitle
        titleKey="JOBS_JOB_DETAILS_SIMILAR_JOBS_HEADLINE"
        size={titleSize}
        sizeConfined={titleSizeConfined}
      />

      {showCarousel ? (
        <>
          <OnlyOnLarge>
            <SimilarJobsGrid similarJobs={similarJobs} ads={ads} />
          </OnlyOnLarge>
          <NotOnLarge>
            <SimilarJobsCarousel similarJobs={similarJobs} ads={ads} />
          </NotOnLarge>
        </>
      ) : (
        <SimilarJobsGrid similarJobs={similarJobs} ads={ads} />
      )}
    </div>
  );
};
